<div class="viewer-shell" [class.viewer-shell-embedded]="embedded" [class.viewer-shell-transparent]="transparentBackground">
  @if (showHeader) {
    <div class="viewer-header">
      <span>Building 3D view</span>
    </div>
  }
  <canvas #renderCanvas class="viewer-canvas" [class.viewer-canvas-loading]="isModelLoading"></canvas>
  @if (isModelLoading && !transparentBackground) {
    <div class="viewer-loading-overlay" aria-live="polite" aria-busy="true">
      <div class="viewer-loading-content">
        <i class="fa-solid fa-spinner fa-spin viewer-loading-spinner"></i>
        <span>Loading 3D model...</span>
      </div>
    </div>
  }
  @if (isModelLoading && transparentBackground) {
    <div class="viewer-loading-indicator" aria-live="polite" aria-busy="true">
      <div class="viewer-loading-content">
        <i class="fa-solid fa-spinner fa-spin viewer-loading-spinner"></i>
        <span>Loading 3D model...</span>
      </div>
    </div>
  }
</div>
